import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Facebook right column on desktop ("Desni stupac na radnoj površini"): image, headline, domain. */
@Component({
  selector: 'app-meta-facebook-right-column',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-right-column.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './facebook-right-column.component.scss'
})
export class MetaFacebookRightColumnPreviewComponent {
  @Input() data!: MetaPreviewData;

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get domain(): string {
    return MetaPreviewCopy.domain(this.data);
  }
}
